import Vue from "vue"
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

var sockets = [];
var urlSocket = 'wss://chathub.allchat.fpt.vn/websocket';
// var urlSocket = 'ws://42.116.254.246:3000//websocket';
const emitter = new Vue({
  
    methods:{
        send(message){
            if (1 === socket.readyState) {
                socket.send(message)

            } else {
                console.log ('Not ready socket')
            }
        },
        close (room) {
            sockets.forEach(function(s) {
                if (1 === s.readyState) {
                    s.close();
                    console.log ('Socket is closing')
                }
            });
        }, 
        init () {

                const socket = new WebSocket("wss://chathub.allchat.fpt.vn/websocket")

                var room = null;
                var token = null;
                if ($cookies.isKey('fpt_livechat')) {
                    token   = $cookies.get("fpt_livechat").token;
                    room    = $cookies.get("fpt_livechat").room;
                } 
                socket.onopen = function(event) {
                    socket.send('{"msg":"connect","version":"1","support":["1","pre2","pre1"]}'); 
                        setInterval(function () {
                            if (socket.readyState  === WebSocket.OPEN) {
                                socket.send('{"msg":"ping"}');      
                            }
                        }, 2000)
    
                    socket.send('{"msg":"sub","name":"stream-room-messages","params":["'+room+'",{"useCollection":false,"args":[{"token":"'+token+'","visitorToken":"'+token+'"}]}],"id":"ddp-1"}');
                }
            
                socket.onmessage = function(msg){
                    emitter.$emit("message", msg.data)
                }
                socket.onerror = function(err){
                    emitter.$emit("error", err)
                }

                socket.onclose = function(event) {
                    console.log("WebSocket is closed now.");
                };

                sockets.push(socket);

        }
        
    }
})



  
export default emitter
